import { Link } from 'react-router-dom';
import { getProductPath } from '@/utils/productLinks';

interface RelatedProduct {
  id: number;
  title: string;
  image: string;
  category: string;
  compliance: string;
}

interface RelatedProductsProps {
  products: RelatedProduct[];
}

export default function RelatedProducts({ products }: RelatedProductsProps) {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">You Might Also Like</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore our complete range of fire safety products and solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <Link
              key={product.id}
              to={getProductPath(product.id)}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
            >
              <div className="relative overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 right-3 bg-green-500 text-white px-2 py-1 rounded text-xs font-medium">
                  {product.compliance}
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-red-600 font-medium mb-2">{product.category}</p>
                <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {product.title}
                </h3>
                <span className="block w-full text-center bg-gray-100 group-hover:bg-red-600 group-hover:text-white text-gray-700 py-2 px-4 rounded-lg font-medium transition-colors whitespace-nowrap">
                  View Details
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}